import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';

export type CopyPopupIcon = 'content_copy' | 'check' | 'error_outline';

@Component({
  standalone: true,
  selector: 'app-copy-selection-popup',
  imports: [MatIconModule],
  templateUrl: './copy-selection-popup.component.html',
  styleUrl: './copy-selection-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopySelectionPopupComponent {
  readonly icon = signal<CopyPopupIcon>('content_copy');
  readonly message = signal('');
  readonly copyRequested = new Subject<void>();

  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
  }
}
